// Плагин подсвечивает содержимое редактора красным при превышении лимита символов.
// Переписан под API TinyMCE 6/7: старые theme.panel / editor.$ / contentStyles удалены.
// eslint-disable-next-line no-undef
tinymce.PluginManager.add("maxchars", function (editor) {
  // значение по умолчанию для свойства maxChars (задаётся в setup редактора)
  editor.maxChars = editor.maxChars || 0;

  if (editor.maxChars <= 0) {
    return;
  }

  function updateStyle() {
    var body = editor.getBody();
    if (!body) {
      return;
    }
    var content = editor.getContent({ format: "text" });

    // добавляем/убираем класс на body iframe в зависимости от длины контента
    if (content.length > editor.maxChars) {
      body.classList.add("maxchars");
    } else {
      body.classList.remove("maxchars");
    }
  }

  editor.on("init", function () {
    // инжектим стиль прямо в документ редактора (iframe)
    editor.dom.addStyle(".maxchars {color: red !important;}");
    updateStyle(); // проверяем стартовый контент
  });

  editor.on("change keyup", updateStyle);
});
